import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { UserFormContext } from 'context';
import type { ComponentMode, User as UserConfig } from 'types';

import { UserForm, UserHeader } from './components';

type UserProps = {
  mode: ComponentMode;
};

export default function User({ mode }: UserProps) {
  const data = useLoaderData() as UserConfig | undefined;

  const { userName, displayName, firstName, lastName, roleName } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode
    ? userName || displayName || `${firstName || 'بدون نام'} ${lastName || ''}`
    : 'افزودن کاربر جدید';
  const defaultName = isUpdatedMode ? displayName || firstName || '' : '';
  const defaultRoleName: typeof roleName = isUpdatedMode ? roleName : undefined;

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <UserHeader>{title}</UserHeader>
      <UserFormContext
        mode={mode}
        defaultName={defaultName}
        defaultRoleName={defaultRoleName}
        ownerType='User'
        {...(isUpdatedMode ? data : {})}
      >
        <UserForm />
      </UserFormContext>
    </React.Fragment>
  );
}
